import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { IRegionConfig } from '../../../../types';

interface Props {
  config: IRegionConfig;
  showRisks: boolean;
  visaSupport?: string;
  riskList?: string[];
}

function VisaSupport({ config, showRisks, visaSupport, riskList = [] }: Props) {
  const visaSupportConfig = config.Checklist.PersonalInfo.Page9.VisaSupport;

  return (
    <>
      {visaSupport && (
        <SummaryRow
          key="visaSupport"
          label="Enroly Visa Support"
          fullLabel={visaSupportConfig?.label}
          value={visaSupport}
          isRisk={showRisks && riskList.includes(Q.VISA_SUPPORT)}
        />
      )}
    </>
  );
}

export default VisaSupport;
